import React, {FC} from 'react';
import { ContentPanelContainer } from './content-panel-contaner';
import { ContentHeader } from './content-header';
import { ContentPanel } from './content-panel';

export const CV:FC = () => {

    return (
        <ContentPanelContainer>
            <ContentHeader headerText="my background"/>
            <ContentPanel>
                My career path has taken some fairly sharp turns so far.  I
                majored in geology and chemistry in my under-graduate studies
                and planetary geology in grad school.  It took me some time to 
                realize that whatever career path I finally chose, it would need 
                to have both analytical and creative components.  I finally found that
                combination in web development.  
            </ContentPanel>
            <ContentPanel>
                Although I've built several web sites in my career, I prefer building 
                interactive, database-driven web applications.  Naturally, I can't 
                display the many proprietary applications I've built or contributed 
                to during my career on this website, my 
                personal <a href="https://wikihikes.com">Wikihikes </a> website 
                is publicly accessible along with a few other personally owned
                websites which can be viewed from this 
                site's  <a href="https://matthewroche.io/portfolio/wikihikes">portfolio</a> section.
                I plan on posting more content to the portfolio section of this site in the 
                weeks and months to come.
            </ContentPanel>
            <ContentPanel>
                I started my web development career on the LAMP stack, but my current
                job has me working in a primarily front-end environment, building
                and maintaining react micro-frontends for a proprietary web application 
                using the Single Spa framework.  The company for which I currently
                work has a fully integrated CI/CD pipeline which utilizes Github, Harness, 
                and AWS.   
            </ContentPanel>
        </ContentPanelContainer>
    )
}